/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Tax_RateInputs */

const en_admin_resource_form_tax_rate = /** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax rate`)
};

const de_admin_resource_form_tax_rate = /** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuersatz`)
};

const es_admin_resource_form_tax_rate = /** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo impositivo`)
};

const fr_admin_resource_form_tax_rate = /** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux de taxe`)
};

/** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */
const it_admin_resource_form_tax_rate = en_admin_resource_form_tax_rate;

/** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */
const pt_br2_admin_resource_form_tax_rate = en_admin_resource_form_tax_rate;

/** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */
const pl_admin_resource_form_tax_rate = en_admin_resource_form_tax_rate;

/** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */
const hu_admin_resource_form_tax_rate = en_admin_resource_form_tax_rate;

/** @type {(inputs: Admin_Resource_Form_Tax_RateInputs) => LocalizedString} */
const ro_admin_resource_form_tax_rate = en_admin_resource_form_tax_rate;

/**
* | output |
* | --- |
* | "Tax rate" |
*
* @param {Admin_Resource_Form_Tax_RateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_tax_rate = /** @type {((inputs?: Admin_Resource_Form_Tax_RateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Tax_RateInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_tax_rate(inputs)
	if (locale === "de") return de_admin_resource_form_tax_rate(inputs)
	if (locale === "es") return es_admin_resource_form_tax_rate(inputs)
	if (locale === "fr") return fr_admin_resource_form_tax_rate(inputs)
	if (locale === "it") return it_admin_resource_form_tax_rate(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_tax_rate(inputs)
	if (locale === "pl") return pl_admin_resource_form_tax_rate(inputs)
	if (locale === "hu") return hu_admin_resource_form_tax_rate(inputs)
	return ro_admin_resource_form_tax_rate(inputs)
});
export { admin_resource_form_tax_rate as "admin.resource_form.tax_rate" }